module.exports = __webpack_public_path__ + "church.png?6d4f9ef42b4697e4b9360888fb86e98a";